import cx from 'classnames';
import {
    bo_ambasadors_url,
    bo_bank_payments_url,
    bo_banners_url,
    bo_brand_days_campaigns_url,
    bo_card_payments_url,
    bo_contests_url,
    bo_counsellings_url,
    bo_customers_url,
    bo_generate_gtad_url,
    bo_invoices_url,
    bo_mail_ads_url,
    bo_sms_payments_url,
    bo_testings_url,
    bo_tracked_hashtags_url,
    bo_traffic_url,
} from 'mk/urls/functions';
import { boOrdersUrl } from 'mk2/apps/bo/urls';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import { hasRequiredPermissions } from 'mk2/helpers/permissions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState, getRequestPermissions } from 'mk2/reducers';
import { MenuSelection } from 'mk2/schemas';
import React from 'react';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import styles from './BoTabs.mscss';

interface BoTabDefinition {
    name: string;
    title: string;
    url: string;
    permission: string | string[];
}

const BO_TABS: BoTabDefinition[][] = [[
    // Finance
    {
        name: 'bank-payments',
        title: 'Bank Payments',
        url: bo_bank_payments_url(),
        permission: 'bo.can_manage_finance',
    },
    {
        name: 'card-payments',
        title: 'Card Payments',
        url: bo_card_payments_url(),
        permission: 'bo.can_manage_finance',
    },
    {
        name: 'sms-payments',
        title: 'SMS Payments',
        url: bo_sms_payments_url(),
        permission: 'bo.can_manage_finance',
    },
    {
        name: 'customers',
        title: 'Pro Plus',
        url: bo_customers_url(),
        permission: 'vendor.can_manage_pro',
    },
    {
        name: 'banners',
        title: 'Agencies',
        url: bo_banners_url(),
        permission: ['bo.can_manage_sales', 'bo.can_manage_finance', 'bo.can_manage_ads'],
    },
    {
        name: 'invoices',
        title: 'Invoices',
        url: bo_invoices_url(),
        permission: 'bo.can_manage_finance',
    },
    {
        name: 'orders',
        title: 'Orders',
        url: boOrdersUrl,
        permission: ['bo.can_manage_sales', 'bo.can_manage_finance', 'bo.can_manage_ads'],
    },
], [
    // Production
    {
        name: 'ambasadors',
        title: 'Ambasadors',
        url: bo_ambasadors_url(),
        permission: ['bo.can_manage_ads', 'bo.can_manage_sales'],
    },
    {
        name: 'contests',
        title: 'Contests',
        url: bo_contests_url(),
        permission: 'bo.can_manage_ads',
    },
    {
        name: 'testings',
        title: 'Testings',
        url: bo_testings_url(),
        permission: 'bo.can_manage_ads',
    },
    {
        name: 'mail-ads',
        title: 'Reklama do IP',
        url: bo_mail_ads_url(),
        permission: ['bo.can_manage_ads', 'bo.can_manage_sales'],
    },
    {
        name: 'brand-days',
        title: 'Dni so značkou',
        url: bo_brand_days_campaigns_url(),
        permission: ['bo.can_manage_ads', 'bo.can_manage_sales'],
    },
    {
        name: 'counsellings',
        title: 'Poradne',
        url: bo_counsellings_url(),
        permission: 'bo.can_manage_ads',
    },
    {
        name: 'traffic',
        title: 'User Traffic',
        url: bo_traffic_url(),
        permission: ['bo.can_manage_ads', 'bo.can_manage_sales'],
    },
    {
        name: 'tracked_hashtags',
        title: 'Tracked hashtags',
        url: bo_tracked_hashtags_url(),
        permission: ['bo.can_manage_ads', 'bo.can_manage_sales'],
    },
    {
        name: 'revive',
        title: 'Ad Manager',
        url: bo_generate_gtad_url(),
        permission: 'bo.can_manage_ads',
    },
]];

interface OwnProps {
    menuSelection?: MenuSelection;
    fluxibleCompatibility: boolean;
}

interface StateProps {
    requestUserPermissions: string[];
}

interface DispatchProps {}

type Props = OwnProps & StateProps & DispatchProps;

class BoTabs extends React.Component<Props> {
    public render() {
        const { requestUserPermissions, menuSelection, fluxibleCompatibility } = this.props;
        const activeItem = menuSelection && menuSelection.activeItem;

        return (
            <div className={styles.BoTabs}>
                {BO_TABS.map((tabsRow) => {
                    const tabs = tabsRow.filter((tab) => hasRequiredPermissions(requestUserPermissions, tab.permission));
                    return tabs.length
                        ? (
                            <div className={styles.BoTabs__tabRow}>
                                {tabs.map((tab) => (
                                    <CompatibleLink
                                        key={tab.name}
                                        className={cx(
                                            styles.BoTabs__tab,
                                            (activeItem === tab.name) && styles['BoTabs__tab--selected'],
                                        )}
                                        to={tab.url}
                                        fluxibleCompatibility={tab.name !== 'orders' || fluxibleCompatibility}
                                    >
                                        {tab.title}
                                    </CompatibleLink>
                                ))}
                            </div>
                        ) : null;
                })}

                <ReduxToastr
                    position="top-center"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                />
            </div>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        requestUserPermissions: getRequestPermissions(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {};

export default connect(mapStateToProps, mapDispatchToProps)(BoTabs);
